/**
 * Footer component with privacy policy link and API documentation links.
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PrivacyPolicyModal from '@/components/modals/PrivacyPolicyModal';
import AboutModal from '@/components/modals/AboutModal';
import { ApiDocsLinks } from '@/components/common/ApiDocsLinks';

const linkStyle = {
  background: 'none',
  border: 'none',
  color: 'var(--myant-primary)',
  cursor: 'pointer',
  textDecoration: 'underline',
  fontSize: '0.875rem',
  padding: 0,
  margin: '0 0.25rem',
} as const;

export default function Footer() {
  const { t } = useTranslation();
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);

  return (
    <>
      <footer
        style={{
          marginTop: 'auto',
          padding: '1.5rem 0',
          borderTop: '1px solid var(--myant-border-color)',
          textAlign: 'center',
          backgroundColor: 'var(--myant-bg-primary)',
        }}
      >
        <div
          style={{
            color: 'var(--myant-text-secondary)',
            fontSize: '0.875rem',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          <span>{t('footer.copyright', { year: new Date().getFullYear() })}</span>
          <span>|</span>
          <button
            onClick={() => setShowPrivacyModal(true)}
            style={linkStyle}
          >
            {t('footer.privacyPolicy')}
          </button>
          <span>|</span>
          <button
            onClick={() => setShowAboutModal(true)}
            style={linkStyle}
          >
            {t('footer.about')}
          </button>
          <ApiDocsLinks />
        </div>
      </footer>
      <PrivacyPolicyModal
        show={showPrivacyModal}
        onHide={() => setShowPrivacyModal(false)}
      />
      <AboutModal
        show={showAboutModal}
        onHide={() => setShowAboutModal(false)}
      />
    </>
  );
}
